export default "__VITE_ASSET__C_PA5jUN__"